import React from "react";
import { StyledShinchanAnimation } from "./StyledShinchanAnimation";

function ShinchanAnimation() {
  return (
    <StyledShinchanAnimation>
      <div className="face">
        <div className="forhead"></div>
        <div className="cheeks"></div>
        <div className="ear"></div>
        <div className="eyebrow left"></div>
        <div className="eyebrow right"></div>
        <div className="eye left"></div>
        <div className="eye right"></div>
        <div className="mouth"></div>
        <div className="shy"></div>
        <div className="shy right"></div>
      </div>
    </StyledShinchanAnimation>
  );
}

export default ShinchanAnimation;
